export const CREATE_USER_FORM_SHIPPING_PLAN = 'CREATE_USER_FORM_SHIPPING_PLAN'


export const NAVIGATE_SHIPPING_PLAN = 'NAVIGATE_SHIPPING_PLAN'

export const NAVIGATE_SHIPPING_PLAN_DETAILS = 'NAVIGATE_SHIPPING_PLAN_DETAILS'

export const CREATE_SHIPPING_PLAN_POST_REQUEST = 'CREATE_SHIPPING_PLAN_POST_REQUEST'
export const CREATE_SHIPPING_PLAN_POST_SUCCESS = 'CREATE_SHIPPING_PLAN_POST_SUCCESS'
export const CREATE_SHIPPING_PLAN_POST_FAILURE = 'CREATE_SHIPPING_PLAN_POST_FAILURE'

export const SHIPPING_PLAN_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'SHIPPING_PLAN_USERFORM_NAVIGATE_TO_DETAIL_TAB'

export const SHIPPING_PLAN_USERFORM_RESET = 'SHIPPING_PLAN_USERFORM_RESET'


export const CREATE_SHIPPING_PLAN_GET_REQUEST = 'CREATE_SHIPPING_PLAN_GET_REQUEST'
export const CREATE_SHIPPING_PLAN_GET_SUCCESS = 'CREATE_SHIPPING_PLAN_GET_SUCCESS'
export const CREATE_SHIPPING_PLAN_GET_FAILURE = 'CREATE_SHIPPING_PLAN_GET_FAILURE'




export const UPDATE_SHIPPING_PLAN_GET_REQUEST = 'UPDATE_SHIPPING_PLAN_GET_REQUEST'
export const UPDATE_SHIPPING_PLAN_GET_SUCCESS = 'UPDATE_SHIPPING_PLAN_GET_SUCCESS'
export const UPDATE_SHIPPING_PLAN_GET_FAILURE = 'UPDATE_SHIPPING_PLAN_GET_FAILURE'


export const DELETE_SHIPPING_PLAN_REQUEST = 'DELETE_SHIPPING_PLAN_REQUEST'
export const DELETE_SHIPPING_PLAN_SUCCESS = 'DELETE_SHIPPING_PLAN_SUCCESS'
export const DELETE_SHIPPING_PLAN_FAILURE = 'DELETE_SHIPPING_PLAN_FAILURE'

export const CREATE_SHIPPING_PLAN_STYLE_NUMBER_REQUEST = 'CREATE_SHIPPING_PLAN_STYLE_NUMBER_REQUEST'
export const CREATE_SHIPPING_PLAN_STYLE_NUMBER_SUCCESS = 'CREATE_SHIPPING_PLAN_STYLE_NUMBER_SUCCESS'
export const CREATE_SHIPPING_PLAN_STYLE_NUMBER_FAILURE = 'CREATE_SHIPPING_PLAN_STYLE_NUMBER_FAILURE'















